import clsx from 'clsx';
import {map} from 'lodash';
import {orderBy} from 'natural-orderby';
import {useState} from 'react';

import Button from 'components/Button';
import Loading from 'components/Loading';
import InlinePage from 'components/Page/Inline';
import KyError from 'components/errors/KyError';
import ReadableWidthTemplate from 'components/templates/ReadableWidth';
import useAppContext from 'conf/AppContext';
import {useGet} from 'helpers/KyHooks';
import AlleleFrequencyGene from 'pages/AlleleFrequency/gene';

export default function AlleleFrequencyOverviewPage({geneId: geneIdProp, pop}) {
  const appContext = useAppContext();
  const [geneId, setGeneId] = useState(geneIdProp);
  const {response, error} = useGet('site/alleleFrequency', {parseJson: true, cacheResponse: !appContext.isPreview});

  let body = <Loading />;
  if (error) {
    body = <KyError kyError={error} />;
  } else if (response) {
    const genes = orderBy(response.data, ['symbol']);
    const handlePick = (id) => () => {
      setGeneId(id);
      const addr = new URL(document.location.href);
      addr.searchParams.set('geneId', id);
      window.history.pushState({path: addr.pathname}, window.title, addr.toString());
    };
    body = (
      <div>
        <InlinePage id="alleleFrequencyHeader" showTitle={false} className="mb-4" />
        <div className="d-flex flex-wrap mb-4" style={{gap: '.4em'}}>
          {map(genes, (g) => (
            <div key={g.id} style={{flex: '0 1 auto'}}>
              <Button className={clsx({'btn-outline-primary': g.id !== geneId, 'btn-primary': g.id === geneId})} actionHandler={handlePick(g.id)}>
                {g.symbol}
              </Button>
            </div>
          ))}
        </div>

        {geneId && <AlleleFrequencyGene id={geneId} population={pop} />}
      </div>
    );
  }

  return (
    <ReadableWidthTemplate title="Allele Frequencies">
      {body}
    </ReadableWidthTemplate>
  );
}
